function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 3.2A2.2 2.2 0 013.2 1h9.6A2.2 2.2 0 0115 3.2v9.6a2.2 2.2 0 01-2.2 2.2H3.2A2.2 2.2 0 011 12.8V3.2zm2.2-1a1 1 0 00-1 1v9.6a1 1 0 001 1h9.6a1 1 0 001-1V3.2a1 1 0 00-1-1H3.2zm8 2a.6.6 0 01.6.6v6.4a.6.6 0 11-1.2 0V4.8a.6.6 0 01.6-.6zM8 6.6a.6.6 0 01.6.6v4a.6.6 0 11-1.2 0v-4a.6.6 0 01.6-.6zM4.8 9a.6.6 0 01.6.6v1.6a.6.6 0 11-1.2 0V9.6a.6.6 0 01.6-.6z",
  fill: "#2D2D2D"
});
function SvgGrfico(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Gráfico.svg";
export { SvgGrfico as ReactComponent };